import { CaseType } from './constants';

export function strip_html_tags(str) {
    if ((str === null) || (str === ''))
        return false;
    else
        str = str.toString();    
    return str.replace(/<[^>]*>/g, '');
};
export function getCaseDetailsImage(type) {
    switch (type) {
        case CaseType.contract: return "contractdetails";
        case CaseType.hearing: return "hearingdetails";
        case CaseType.matter: return "matterdetails";
        case CaseType.litigation: return "litigationdetails";
        default: return type;
    }
}